import React, {Component} from 'react';
import {withStyles} from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import {connect} from 'react-redux';
import {fetchManagers} from "../state/actions/managers";
import Button from '@material-ui/core/Button';
import logoMark from '../assets/images/welcome-logomark.png';

class WelcomeModal extends Component {
  constructor(props) {
    super(props);
  }

  componentDidMount() {
    window.analytics.track("Business Dashboard - Welcome Modal Opened", {slug: this.props.business.slug});
    this.props.fetchManagers(this.props.business);
  }

  closeModal = () => {
    window.analytics.track("Business Dashboard - Welcome Modal Closed", {slug: this.props.business.slug});
    this.props.closeModal();
  };

  render() {
    const {classes} = this.props;

    return (
      <div style={getModalStyle()} className={classes.content}>
        <img className={classes.logo} src={logoMark}/>
        <Typography className={classes.title} variant='headline'>Hello {this.props.manager && this.props.manager.name},</Typography>
        <Typography className={classes.title} variant='headline'>Welcome to SingleShift</Typography>
        <Typography className={classes.brief} variant='body2'>Let's get you up and running.</Typography>
        <Button onClick={this.closeModal} variant="raised" color={'primary'} className={classes.createButton}>Okay</Button>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  business: state.business.item,
  manager: state.managers.items && state.managers.items[0],
});

const mapDispatchToProps = (dispatch) => {
  return {
    fetchManagers: (business) => dispatch(fetchManagers(business)),
  }
};

function getModalStyle() {
  const top = 50;
  const left = 50;

  return {
    top: `${top}%`,
    left: `${left}%`,
    transform: `translate(-${top}%, -${left}%)`,
  };
}

const styles = (theme) => ({
  content: {
    position: 'absolute',
    width: '90%',
    maxWidth: theme.spacing.unit * 50,
    backgroundColor: theme.palette.background.paper,
    boxShadow: theme.shadows[5],
    padding: `${theme.spacing.unit * 6}px ${theme.spacing.unit * 4}px`,
    textAlign: 'center',
    borderRadius: '8px',
  },
  logo: {
    marginBottom: '24px',
    width: '120px',
  },
  title: {
    paddingBottom: theme.spacing.unit
  },
  brief: {
    paddingBottom: theme.spacing.unit * 3
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(WelcomeModal));



// WEBPACK FOOTER //
// ./src/modals/WelcomeModal.js